module.exports = __webpack_public_path__ + "img/img.789d8049.jpg";